/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import commonStyles from '../components/MessageToolbar/MessageToolbarCommon.module.scss';

const FeedbackIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" fontSize="large">
    <rect width="34" height="34" fill="transparent" />
    <path
      d="M24 9H10C8.346 9 7 10.346 7 12V27C7 27.36 7.194 27.693 7.507 27.87C7.66 27.957 7.83 28 8 28C8.178 28 8.356 27.953 8.515 27.857L13.039 25.143C13.195 25.049 13.373 25 13.554 25H24C25.654 25 27 23.654 27 22V12C27 10.346 25.654 9 24 9Z"
      fill="#4E6088"
    />
    <path
      d="M25 22C25 22.551 24.551 23 24 23H13.554C13.011 23 12.477 23.148 12.01 23.428L9 25.234V12C9 11.449 9.449 11 10 11H24C24.551 11 25 11.449 25 12V22Z"
      fill="#E6EDF5"
      className={commonStyles.pathInterior}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 17C12 16.448 12.448 16 13 16C13.552 16 14 16.448 14 17C14 17.552 13.552 18 13 18C12.448 18 12 17.552 12 17ZM17 16C16.448 16 16 16.448 16 17C16 17.552 16.448 18 17 18C17.552 18 18 17.552 18 17C18 16.448 17.552 16 17 16ZM21 16C20.448 16 20 16.448 20 17C20 17.552 20.448 18 21 18C21.552 18 22 17.552 22 17C22 16.448 21.552 16 21 16Z"
      fill="#4E6088"
    />
  </SvgIcon>
);
export default FeedbackIcon;
